import React from "react"
import { graphql, PageProps } from "gatsby"
import Layout from "../components/layout"
import { Heading, Text } from "@chakra-ui/react"
import SEO from "../components/seo"
import ReactMarkdown from "react-markdown"
import Container from "../components/styles/Container"

interface Props extends PageProps {
  pageContext: {
    slug: string
    title: string
    body: {
      body: string
    }
  }
}

interface RenderProps {
  value: string
  node: {
    children: [{ value: string }]
  }
  level?: 1 | 2 | 3 | 4 | 5 | 6
}

const renderers = {
  paragraph: ({ value, node }: RenderProps) => (
    <Text my={2}>{node.children[0].value}</Text>
  ),
  heading: ({ node, level }: RenderProps) => (
    // @ts-ignore
    <Heading my={2} as={`h${level || 1}`}>
      {node.children[0].value}
    </Heading>
  ),
}

function StandardPage(props: Props) {
  return (
    <>
      <SEO
        title={props.pageContext.title || "Product"}
        description={props.pageContext.title}
      />
      <Container minH="70vh" my="50px" maxW="1000px">
        <Heading size="2xl" as="h1" textDecoration="underline" mb="30px">
          {props.pageContext.title}
        </Heading>
        <ReactMarkdown renderers={renderers}>
          {props.pageContext.body.body}
        </ReactMarkdown>
      </Container>
    </>
  )
}

export default StandardPage
